import { render } from "./ErrorRegistered.vue?vue&type=template&id=0fb60f16"
import script from "./ErrorRegistered.vue?vue&type=script&lang=js"
export * from "./ErrorRegistered.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__